import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }}
    >
      <Result
        status="404"
        title="404"
        subTitle="Lo sentimos, la página a la que esta intentando acceder no existe."
      />
      <Button type="link" onClick={() => navigate('/')}>
        Volver
      </Button>
    </div>
  );
};

export default NotFound;
